import { TagifyTagsHTMLElement } from '../types/tagify';

export function initAcmeAddDomainForm(): void {
    document.querySelectorAll<HTMLFormElement>('.js-acme-add-domain-form').forEach($form => {
        new AcmeAddDomainForm($form);
    });
}

class AcmeAddDomainForm {
    $form: HTMLFormElement;
    $domainsField: TagifyTagsHTMLElement;
    $validationMethodField: HTMLSelectElement;

    constructor($form: HTMLFormElement) {
        this.$form = $form;
        this.$domainsField = $form.querySelector<TagifyTagsHTMLElement>('.js-acme-domain-field');
        this.$validationMethodField = $form.querySelector('.js-acme-domain-validation-method-field') as HTMLSelectElement;

        ['add', 'remove', 'edit:updated'].forEach(action => {
            this.$domainsField.__tagify.on(action, () => {
                validateValidationMethod(this.$domainsField, this.$validationMethodField);
            });
        });

        this.$validationMethodField.addEventListener('change', () => {
            validateValidationMethod(this.$domainsField, this.$validationMethodField);
        });
    }
}

/**
 * Un nom de domaine wildcard doit obligatoirement avoir une méthode de validation de DCV via DNS
 *
 * @param {TagifyTagsHTMLElement|HTMLInputElement} $domainsField
 * @param {HTMLSelectElement} $validationMethodField
 *
 * @return {void}
 */
export function validateValidationMethod($domainsField: TagifyTagsHTMLElement|HTMLInputElement, $validationMethodField: HTMLSelectElement): void {
    let havingWildcard = false;
    const domains: { value: string }[] = 'undefined' !== typeof $domainsField.__tagify
        ? $domainsField.__tagify.getCleanValue()
        : [{ value: $domainsField.value }];

    domains.forEach(domain => {
        if (!havingWildcard && domain.value.startsWith('*.')) {
            havingWildcard = true;
        }
    });

    if (havingWildcard) {
        $validationMethodField.querySelectorAll<HTMLOptionElement>('option').forEach($option => {
            $option.selected = $option.value === 'DNS';
        });

        $validationMethodField.setAttribute('readonly', 'readonly');
    } else {
        $validationMethodField.removeAttribute('readonly');
    }
}
